import React, { useState,useEffect } from 'react';
import "../styles/global.css";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
     <footer className="footer">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-sm-6">
                        2025 © Imaxell.
                    </div>
                    <div className="col-sm-6">
                        <div className="text-sm-end d-none d-sm-block">
                            All Rights Reserved
                        </div>
                    </div>
                </div>
            </div>
        </footer>
  );
};

export default Footer;
